module.exports = __webpack_public_path__ + "img/flag-AR.2e41c832.svg";